import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import { Section, Eyebrow, Reveal } from "@/components/site/Primitives";

export default function RiskWarning() {
  const { t } = useI18n();
  const bullets = t("risk.bullets");

  return (
    <Section className="pt-28 md:pt-40 min-h-[80vh] pb-40">
      <div className="max-w-4xl">
        <Eyebrow>{t("risk.eyebrow")}</Eyebrow>
        <Reveal>
          <h1 className="mt-6 font-display font-light text-4xl md:text-6xl leading-[0.98] tracking-[-0.03em]">
            {t("risk.pageTitle")}
          </h1>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 border border-foreground p-6 md:p-8 flex items-start gap-4">
            <AlertTriangle className="w-6 h-6 shrink-0 mt-1" />
            <div>
              <p className="font-display text-xl md:text-2xl tracking-tight">{t("risk.headline")}</p>
              <p className="mt-4 text-[15px] leading-relaxed text-muted-foreground">{t("risk.body")}</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <h2 className="mt-14 font-display text-2xl tracking-tight">{t("risk.keyRisksTitle")}</h2>
          <ul className="mt-6 space-y-4">
            {bullets.map((b, i) => (
              <li key={i} className="grid grid-cols-[auto_1fr] gap-4 border-t border-border pt-4">
                <span className="font-mono text-[11px] tracking-widest text-muted-foreground pt-1">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <p className="font-display text-lg tracking-tight">{b.t}</p>
                  <p className="mt-2 text-[14px] leading-relaxed text-muted-foreground">{b.d}</p>
                </div>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-14 border-t border-border pt-8 space-y-4 text-[13px] leading-relaxed text-muted-foreground">
            <p>{t("risk.statutory1")}</p>
            <p>{t("risk.statutory2")}</p>
            <p>{t("risk.statutory3")}</p>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-10 flex flex-wrap gap-4 text-[12px] tracking-widest uppercase">
            <Link to="/" data-testid="risk-back-home" className="border-b border-foreground pb-1">← {t("common.backToHome")}</Link>
            <Link to="/contact" data-testid="risk-contact" className="border-b border-foreground pb-1">{t("common.contactUs")}</Link>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
